import { IClientAssociationModel } from '../Types/ClientModelTypes';
import { findAssociations } from './avenyModelUtils';
import { collectionMap } from './ModelContext/ModelContext';

export const findAssociationsStatic = (
  collectionName: string,
  associationNames: string[]
): IClientAssociationModel[] =>
  findAssociations(collectionName, associationNames, collectionMap);
